import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dev/style-guide")({
	component: StyleGuide,
});

function StyleGuide() {
	return (
		<div className="mx-auto max-w-4xl px-6 py-12">
			<h1 className="mb-2 text-2xl font-semibold">Style Guide</h1>
			<p className="text-muted">
				Design tokens, typography, and component gallery. Content coming
				soon.
			</p>
		</div>
	);
}
